import { useFrame } from '~/shared/utils';
import { notifyError } from '../toast';
import { useEvents } from '~/shared/hooks/useEvents';

export const useErrorHandler = () => {
    const { data: frame } = useFrame();
    const { errorEvent } = useEvents(frame);

    function createError(error: any) {
        return error instanceof Error ? error : new Error(error);
    }
    function trackError(err: string, innerError: Error) {
        try {
            errorEvent(err, innerError);
        } catch (e) {
            console.error(e);
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const trackAndDisplayError = (error: any | Error, innerError?: any | Error) => {
        const err = createError(error);

        notifyError(err);
        trackError(error, innerError);
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const trackOnlyError = (error: any | Error, innerError?: any | Error) => {
        trackError(error, innerError);
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const displayOnlyError = (error: any | Error) => {
        const err = createError(error);
        notifyError(err);
    };

    return { trackAndDisplayError, trackOnlyError, displayOnlyError };
};
